export const SAVE_TOKEN = '@@secrets/token'
export const RESET_SECRETS = '@@secrets/reset'
